/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Verify_All_DoneInputs */

const cs_portals_verify_all_done = /** @type {(inputs: Portals_Verify_All_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stavy portálů obnoveny z live kontrol.`)
};

const en_portals_verify_all_done = /** @type {(inputs: Portals_Verify_All_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal statuses refreshed from live checks.`)
};

/**
* | output |
* | --- |
* | "Portal statuses refreshed from live checks." |
*
* @param {Portals_Verify_All_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify_all_done = /** @type {((inputs?: Portals_Verify_All_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Verify_All_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify_all_done(inputs)
	return cs_portals_verify_all_done(inputs)
});